import { finish, error } from '../../../modules/customers/actions/referal-validation';

import api from '../../../api';

export function request(dispatch, { customerId }) {
    api.get(`/referal-betslip/validation/${customerId}/referal`).then(
        (response) => dispatch(finish(customerId, response)),
        ({ errors }) => dispatch(error(customerId, errors))
    );
}
